import API from "../utility/axios";
const oldApiUrl = "/api/v1";

export const FILE_UPLOADS = (data: any): Promise<any[]> => {
  return API.post(`${oldApiUrl}/file`, data);
};
